import { Toggle, TOGGLE_SIZES } from 'ui/toggle';

import { useJsonViewModeContext } from './context/JsonViewModeContext';

export const JsonModeToggle = () => {
  const { isActive, isRawJson, toggleViewMode } = useJsonViewModeContext();
  if (!isActive) {
    return null;
  }

  return (
    <div>
      <label id="json-mode-label" htmlFor="json-mode">
        JSON
      </label>
      <Toggle
        isActive={isRawJson}
        id="json-mode"
        labelId="json-mode-label"
        aria-labelledby="json-mode-label"
        onClick={toggleViewMode}
        size={TOGGLE_SIZES.SMALL}
      />
    </div>
  );
};
